import { useQuery } from "@tanstack/react-query";
import type { RollApplication, RollMaterial } from "../models/RollApplication";
import {
	getRollApplications,
	getRollMaterials,
} from "../repositories/RollApplicationsRepository";

export const ROLL_APPLICATIONS_QUERY_KEYS = {
	all: ["rollApplications"] as const,
	list: () => ["rollApplications", "list"] as const,
	byId: (id: number | null) => ["rollApplications", "detail", id] as const,
	rollMaterials: ["rollApplications", "rollMaterials"] as const,
};

export const useRollApplications = () => {
	const query = useQuery<RollApplication[], Error>({
		queryKey: ROLL_APPLICATIONS_QUERY_KEYS.list(),
		queryFn: () => getRollApplications(),
	});

	return {
		rollApplications: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};

export const useRollMaterials = () => {
	return useQuery<RollMaterial[], Error>({
		queryKey: ROLL_APPLICATIONS_QUERY_KEYS.rollMaterials,
		queryFn: getRollMaterials,
		staleTime: 5 * 60 * 1000,
	});
};
